import { Component, Input  } from '@angular/core';
import { Video } from '../../models/video';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-video',
  imports: [MatCardModule, MatButtonModule],
  templateUrl: './video.component.html',
  styleUrl: './video.component.css',
})
export class VideoComponent {
  @Input() video!: Video;
}
